<template>
  <div class="defaultLiveEventDetail">
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="getLoadingDetail"
    ></v-progress-linear>
    <transition-group name="card-in-out">
      <v-card
        class="event-card-detail event-card-live-detail"
        elevation="1"
        v-for="(object, index) in getEventsLiveDetail"
        :key="index + '_detail'"
        v-if="!checkIsMobile() && !checkIsTablet()"
      >
        <div class="event-card-header">
          <span class="label-live">{{ $t('live') }}</span>
          <span class="sport-text" :title="object.sport.name">
            <img
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
            {{ object.sport.name }}
          </span>

          <span class="category-text" :title="object.category.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
            {{ object.category.name }}
          </span>

          <span :class="['tournament-text']" :title="object.tournament.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.tournament.name }}
          </span>

          <span class="desc-event highlight" :title="object.event.description">
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.event.description }}
          </span>
          <span class="close-card cursor-pointer">
            <v-icon
              dense
              @click="removeDetail(object.event.source, object.event.type)"
              >mdi-close-box</v-icon
            >
          </span>
        </div>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');height: 150px;background-size: cover;'
          "
          v-if="object.event.type == 'match' && !getField(object.event)"
        >
          <v-col
            cols="12"
            md="5"
            :class="[
              'no-padding',
              'align-middle',
              'flex-end',
              getLoser(object.event.livescore.Scoreboard.Results, 'home')
                ? 'loser'
                : '',
            ]"
          >
            <div class="competitor">
              <div class="name">{{ object.event.competitors.home.name }}</div>
              <!--              <div class="flag" :title="object.event.competitors.home.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.home.id+'.png'"-->
              <!--                     :alt="object.event.competitors.home.name">-->
              <!--              </div>-->
            </div>
            <div class="team-result-home">
              {{ getResult(object.event.livescore.Scoreboard.Results, 'home') }}
            </div>
          </v-col>

          <v-col cols="12" md="2" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span
                class="time"
                v-if="
                  getMatchCurrentTime(object.event.livescore.Scoreboard.Time) >
                  0
                "
              >
                <v-progress-circular
                  :rotate="270"
                  :size="90"
                  :width="5"
                  :value="
                    getMatchCurrentTime(object.event.livescore.Scoreboard.Time)
                  "
                  color="white"
                >
                  {{
                    getMatchCurrentTime(object.event.livescore.Scoreboard.Time)
                  }}
                  <span class="blink_me">'</span>
                </v-progress-circular>
              </span>
              <span class="current-period">{{
                getMatchCurrentPeriod(
                  object.event.livescore.Scoreboard.CurrentPeriod
                )
              }}</span>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="2"
            :class="[
              'no-padding',
              'align-middle',
              'flex-start',
              getLoser(object.event.livescore.Scoreboard.Results, 'away')
                ? 'loser'
                : '',
            ]"
          >
            <div class="team-result-away">
              {{ getResult(object.event.livescore.Scoreboard.Results, 'away') }}
            </div>
            <div class="competitor away">
              <!--              <div class="flag" :title="object.event.competitors.away.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
              <!--                     :alt="object.event.competitors.away.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.away.name }}</div>
            </div>
          </v-col>
        </v-row>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundDetailPath +
            object.sport.id +
            '.webp\');background-size: cover;background-position: center center;'
          "
          v-else-if="object.event.type == 'match' && getField(object.event)"
        >
          <div class="d-flex-center" style="display: flex; flex: 5 1 auto">
            <v-col
              cols="12"
              md="5"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'home')
                  ? 'loser'
                  : '',
              ]"
              style="justify-content: flex-end"
            >
              <div class="competitor competitor-with-field">
                <!--                <div class="flag" :title="object.event.competitors.home.name">-->
                <!--                  <img :src="flagTeamsPath+object.event.competitors.home.id+'.png'"-->
                <!--                       :alt="object.event.competitors.home.name">-->
                <!--                </div>-->
                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
              <div class="team-result-home team-result-home-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'home')
                }}
              </div>
            </v-col>

            <v-col cols="12" md="2" class="align-middle flex-center">
              <div class="match-date">
                <span
                  class="time"
                  v-if="
                    getMatchCurrentTime(
                      object.event.livescore.Scoreboard.Time
                    ) > 0
                  "
                >
                  <v-progress-circular
                    :rotate="270"
                    :size="90"
                    :width="5"
                    :value="
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    "
                    color="white"
                  >
                    {{
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    }}
                    <span class="blink_me">'</span>
                  </v-progress-circular>
                </span>
                <span class="current-period">{{
                  getMatchCurrentPeriod(
                    object.event.livescore.Scoreboard.CurrentPeriod
                  )
                }}</span>
                <span
                  v-if="
                    getUserType == 4 ||
                    getCashier ||
                    !getSettings.enableQuickBetOnlyForAgency
                  "
                  class="event-qbet"
                  title="qbet"
                >
                  {{ object.event.quickbet }}
                </span>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="5"
              :class="[
                'align-middle',
                'flex-start',
                getLoser(object.event.livescore.Scoreboard.Results, 'away')
                  ? 'loser'
                  : '',
              ]"
            >
              <div class="team-result-away team-result-away-with-field">
                {{
                  getResult(object.event.livescore.Scoreboard.Results, 'away')
                }}
              </div>
              <div class="competitor away competitor-with-field">
                <div class="name">{{ object.event.competitors.away.name }}</div>
                <!--                <div class="flag" :title="object.event.competitors.away.name">-->
                <!--                  <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
                <!--                       :alt="object.event.competitors.away.name">-->
                <!--                </div>-->
              </div>
            </v-col>
          </div>
          <div
            style="display: flex; flex: auto; justify-content: flex-end"
            v-if="enableLiveField"
          >
            <LiveFieldWidget></LiveFieldWidget>
          </div>
        </v-row>

        <v-row class="no-padding no-margin" style="min-height: 900px">
          <v-col cols="12" sm="12" md="12" v-if="object.event.type == 'match'">
            <v-tabs v-model="tab" grow class="tabs-list">
              <v-tab
                class="group-tab"
                v-for="(group, index) in object.groupMarkets"
                :key="index + '_group_detail'"
                @click="
                  getOddsGroup(
                    object.event.id,
                    group.group_id,
                    object.sport.id,
                    object.tournament.id ? object.tournament.id : ''
                  )
                "
              >
                {{ group.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(group, index) in object.groupMarkets"
                :key="index + '_group_detail_odds'"
              >
                <v-card color="basil" flat v-if="!tab_loading">
                  <masonry :cols="3" :gutter="20">
                    <div
                      v-for="(market, index) in object.event.odds"
                      :key="$uuid.v1()"
                      v-if="market.odds.length > 0 && checkLocked(market)"
                    >
                      <div class="market-box">
                        <div class="market-header">
                          {{ market.name_market }}
                          {{ market.specifiers != '' ? market.specifiers : '' }}
                        </div>
                        <div class="market-content">
                          <div
                            v-for="(odd, index) in market.odds"
                            :key="$uuid.v1()"
                            v-if="
                              (odd.active ||
                                (market.showLocked && !odd.active)) &&
                              !odd.unique_id.includes('undefined')
                            "
                            @click="
                              putCart(
                                odd,
                                object.event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div class="odd-button">
                              <div
                                :class="[
                                  'sign',
                                  getOddsSources.includes(odd.unique_id)
                                    ? 'odd_selected'
                                    : '',
                                ]"
                              >
                                {{ odd.outcome_name }}
                                {{ getSpecifiers(odd.market_unique_id) }}
                              </div>
                              <div
                                v-if="odd.outcome_odd_value > 1.0 && odd.active"
                                :class="[
                                  'value',
                                  'multi-' + market.multiplicity_min,
                                  odd.type_change != undefined
                                    ? 'odd_value_' + odd.type_change
                                    : 'odd_value_equal',
                                  getOddsSources.includes(odd.unique_id)
                                    ? 'odd_selected'
                                    : '',
                                ]"
                              >
                                <!--                                <v-icon class="arrow-up" v-if="odd.type_change == 'up'">mdi-arrow-up</v-icon>-->
                                <!--                                <v-icon class="arrow-down" v-if="odd.type_change == 'down'">mdi-arrow-down</v-icon>-->
                                {{ odd.outcome_odd_value | odds_type_filter }}
                              </div>
                              <div
                                v-else
                                class="value"
                                :class="'multi-' + market.multiplicity_min"
                              >
                                <v-icon dense>mdi-lock</v-icon>
                              </div>
                              <div
                                :class="[
                                  odd.type_change != undefined
                                    ? odd.type_change
                                    : 'equal',
                                ]"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </masonry>
                </v-card>
                <v-card v-else>
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="date-picker"
                  ></v-skeleton-loader>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        class="event-card-detail event-card-live-detail event-card-live-detail-mobile"
        elevation="1"
        v-for="(object, index) in getEventsLiveDetail"
        :key="object.event.source"
        v-else-if="checkIsMobile() || checkIsTablet()"
      >
        <div class="event-card-header">
          <span class="sport-text" :title="object.sport.name">
            <img
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
          </span>
          <span class="category-text" :title="object.category.name">
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
          </span>
          <!--            <span class="tournament-text" :title="object.tournament.name">-->
          <!--            {{ object.tournament.name }} <v-icon dense>mdi-chevron-right</v-icon>-->
          <!--            </span>-->

          <span class="desc-event highlight" :title="object.event.description">
            {{ object.event.description }}
          </span>
          <span class="close-card cursor-pointer">
            <v-icon
              dense
              @click="removeDetail(object.event.source, object.event.type)"
              >mdi-close-box</v-icon
            >
          </span>
        </div>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundDetailPath +
            object.sport.id +
            '.webp\');background-position: bottom;'
          "
          v-if="object.event.type == 'match'"
        >
          <div class="d-flex-center" style="display: flex; flex: 5 1 auto">
            <v-col
              xs="2"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'home')
                  ? 'loser'
                  : '',
              ]"
            >
              <div class="competitor competitor-with-field">
                <div class="name">{{ object.event.competitors.home.name }}</div>
              </div>
            </v-col>

            <v-col xs="8" class="align-middle flex-center">
              <div class="match-date">
                <div class="result">
                  <div class="team-result-home">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'home'
                      )
                    }}
                  </div>
                  <div class="separator">:</div>
                  <div class="team-result-away">
                    {{
                      getResult(
                        object.event.livescore.Scoreboard.Results,
                        'away'
                      )
                    }}
                  </div>
                </div>
                <div class="info-live">
                  <span class="current-period"
                    >{{
                      getMatchCurrentTime(
                        object.event.livescore.Scoreboard.Time
                      )
                    }}
                    <span class="blink_me">'</span> -
                    {{
                      getMatchCurrentPeriod(
                        object.event.livescore.Scoreboard.CurrentPeriod
                      )
                    }}
                  </span>
                </div>
              </div>
            </v-col>

            <v-col
              xs="2"
              :class="[
                'align-middle',
                getLoser(object.event.livescore.Scoreboard.Results, 'away')
                  ? 'loser'
                  : '',
              ]"
              style="justify-content: flex-end"
            >
              <div class="competitor away competitor-with-field">
                <div class="name">{{ object.event.competitors.away.name }}</div>
              </div>
            </v-col>
          </div>

          <div
            style="display: flex; flex: auto; justify-content: flex-end"
            v-if="enableLiveField"
          >
            <LiveFieldWidget></LiveFieldWidget>
          </div>

          <div
            style="
              display: flex;
              flex: 0 0 100%;
              justify-content: center;
              margin-top: -15px;
            "
          >
            <span style="font-size: 10px">{{ object.tournament.name }}</span>
          </div>
        </v-row>

        <v-row v-if="checkIsMobile()">
          <Statscore></Statscore>
        </v-row>

        <v-row class="no-padding no-margin">
          <v-col cols="12" md="12" v-if="object.event.type == 'match'">
            <v-slide-group show-arrows class="pt-2 pb-2" active-class="success">
              <v-slide-item
                v-for="group in object.groupMarkets"
                :key="$uuid.v1()"
              >
                <v-btn
                  small
                  class="mx-2"
                  depressed
                  rounded
                  @click="
                    getOddsGroup(
                      object.event.id,
                      group.group_id,
                      object.sport.id,
                      object.tournament.id ? object.tournament.id : ''
                    )
                  "
                  :class="
                    groupSelected == group.group_id ? 'group-odds-active' : ''
                  "
                >
                  <span class="text-sport text-capitalize">
                    {{ group.name }}</span
                  >
                </v-btn>
              </v-slide-item>
            </v-slide-group>
            <!--            -->
            <!--            <v-tabs v-model="tab" grow class="tabs-list">-->
            <!--              <v-tab class="group-tab" v-for="group in object.groupMarkets" :key="group.id"-->
            <!--                     @click="getOddsGroup(object.event.id, group.group_id,object.sport.id,(object.tournament.id)?object.tournament.id:'')">-->
            <!--                {{ group.name }}-->
            <!--              </v-tab>-->
            <!--            </v-tabs>-->

            <!--            <v-tabs-items v-model="tab">-->
            <!--              <v-tab-item v-for="group in object.groupMarkets" >-->
            <v-card
              color="basil"
              flat
              v-if="!tab_loading"
              class="group-odds-mobile"
            >
              <template v-if="checkExists(object.event.odds)">
                <div
                  v-for="(market, index) in object.event.odds"
                  v-if="market.odds.length > 0 && checkLocked(market)"
                >
                  <div class="market-box">
                    <div class="market-header">
                      {{ market.name_market }}
                      {{ market.specifiers != '' ? market.specifiers : '' }}
                    </div>
                    <div class="market-content">
                      <div
                        v-for="(odd, index) in market.odds"
                        v-if="
                          (odd.active || (market.showLocked && !odd.active)) &&
                          !odd.unique_id.includes('undefined')
                        "
                        @click="
                          putCart(
                            odd,
                            object.event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                      >
                        <div class="odd-button">
                          <div
                            :class="[
                              'sign',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            {{ odd.outcome_name }}
                            {{ getSpecifiers(odd.market_unique_id) }}
                          </div>
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            :class="[
                              'value',
                              'multi-' + market.multiplicity_min,
                              odd.type_change != undefined
                                ? 'odd_value_' + odd.type_change
                                : 'odd_value_equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            <!--                                <v-icon class="arrow-up" v-if="odd.type_change == 'up'">mdi-arrow-up</v-icon>-->
                            <!--                                <v-icon class="arrow-down" v-if="odd.type_change == 'down'">mdi-arrow-down</v-icon>-->
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + market.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                          <div
                            :class="[
                              odd.type_change != undefined
                                ? odd.type_change
                                : 'equal',
                            ]"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <h3 class="no-odds-message">
                  <v-icon large>mdi-trophy-variant-outline</v-icon>
                  <br />{{ $t('noOddsForThisGroup') }}
                </h3>
              </template>
            </v-card>
            <v-card v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="date-picker"
              ></v-skeleton-loader>
            </v-card>
            <!--              </v-tab-item>-->
            <!--            </v-tabs-items>-->
          </v-col>
        </v-row>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from "lodash";
import LiveFieldWidget from '@/components/generic/LiveFieldWidget'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'

const Statscore = () => ({
  component: import('@/components/right_widgets/Statscore'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'DefaultLiveDetail',
  components: { LiveFieldWidget, Statscore },
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    enableLiveField: false,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    groupSelected: 0,
    tab: null,
    tab_loading: false,
    loading: false,
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT+'/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    flagTeamsPath: process.env.VUE_APP_URL_FLAG_TEAMS_CLOUDFRONT + '/medium/',
    // sportBackgroundPath: process.env.VUE_APP_URL_SIRPLAY_CLOUDFRONT + '/platform/elements/background/',
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
    sportBackgroundDetailPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg-detail/',
    noOdds: false,
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromLiveDetail: 'odds/removeFromLiveDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      fetchOddsGroupLiveDetail: 'odds/fetchOddsGroupLiveDetail',
      setLoadingDetail: 'odds/setLoadingDetail',
      addOddToCart: 'cart/addOddToCart',
      setEventStatscore: 'odds/setEventStatscore',
    }),

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    removeDetail(sourceEvent, type) {
      this.tab = null
      this.removeFromLiveDetail({ source: sourceEvent, type: type })
      this.$root.$emit('forceUpdateLivePreview')
    },
    async getOddsGroup(eventSource, groupId, sport, tournament) {
      if (groupId != this.groupSelected) {
        this.groupSelected = groupId
        this.tab_loading = true
        await this.setLoadingDetail({ status: true })

        await this.fetchOddsGroupLiveDetail({
          source: eventSource,
          group: groupId,
          sport: sport,
          tournament: tournament,
        })

        await this.setLoadingDetail({ status: false })
        this.tab_loading = false
      }
    },

    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        return minutes
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    getLoser(result, type) {
      const home_point = _.find(result, { Position: '1' })
      const away_point = _.find(result, { Position: '2' })
      if (type == 'home') {
        return +home_point.Value < +away_point.Value
      } else if (type == 'away') {
        return +away_point.Value < +home_point.Value
      }
    },
    getField(object) {
      return true
    },
    isActiveMarket(odds) {
      const check = _.find(odds, { active: true })
      if (check) {
        return true
      } else {
        return false
      }
    },
    checkHugeMarket(odds) {
      return _.size(odds) > 10 ? true : false
    },
    checkLocked(market) {
      if (market.id_market == 9607444846 || market.id_market == 7055540925) {
        return true
      } else {
        const check = _.find(market.odds, { active: true })
        return !(market.odds.length >= 2 && !check)
      }
    },
    getSpecifiers(spec) {
      let result = ''

      if (!spec) {
        return result
      }

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    checkExists(odds) {
      let result = false
      _.forEach(odds, market => {
        _.forEach(market.odds, odd => {
          if (odd.active == true) {
            result = true
          }
        })
      })

      return result
      // console.log(odds)
      // var check = _.find(odds, {'showMarket': true})
      // return !!check;
    },
  },
}
</script>

<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.basil {
  height: 100%;
  min-height: 900px;
}
</style>
